import { getUser } from '../../modules/contexts/Auth/RequireAuth';
import httpClient from '../httpClient';

// Busca relatórios de um usuário específico
export async function getRelatorios() {
  try {
    const user = getUser();
    const userID = user.sub;

    const response = await httpClient.get(`/api/relatorios/user/${userID}`);

    // Verifica se a resposta da API contém o array `relatorios`
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (Array.isArray(response.data.relatorios)) {
      return response.data.relatorios;
    } else {
      console.error('Estrutura de dados inesperada:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Erro ao obter lista de relatórios:', error);
    throw new Error('Erro ao obter lista de relatórios: ' + error);
  }
}

// Busca todos os relatórios (sem filtro por usuário)
export async function getAllRelatorios() {
  try {
    const response = await httpClient.get(`/api/relatorios`);

    // Verifica se a resposta da API contém o array `relatorios`
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (Array.isArray(response.data.relatorios)) {
      return response.data.relatorios;
    } else {
      console.error('Estrutura de dados inesperada:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Erro ao obter lista de relatórios:', error);
    throw new Error('Erro ao obter lista de relatórios: ' + error);
  }
}
